import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';

//FireBase Authentication Service
@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {
  userData: Observable<firebase.default.User>;
  user: Observable<any>;
  constructor(private angularFireAuth: AngularFireAuth, private angularFireStore: AngularFirestore) {
  }
  
  /* Sign in */
  SignIn() {
    this.angularFireAuth
      .signInAnonymously()
      .then(() => {
        console.log('Successfully signed in!');
      })
      .catch(err => {
        console.log('Something is wrong:',err.message);
    });
  }

  /* Sign out */
  SignOut() {
    this.angularFireAuth
      .signOut();
  }  
}
